import React from "react";
import { Box, Divider, Typography } from "@material-ui/core";
import { PropertyImageCard } from "../PropertyImageCard";
import { PropertyVideoCard } from "../PropertyVideoCard";

// styles
import useStyles from "./styles";

function SectionPropertyGalleryList({
  sectionList,
  setRefetchDataPropertyImage,
  setRefetchDataPropertyVideo,
}) {
  const styles = useStyles();

  return (
    <>
      {sectionList.map((section, index) => (
        <Box key={index} className={styles.containerImageSection}>
          <Box className={styles.containerImageTitle}>
            {section?.icon}
            <Typography className={styles.ImageVedioTitle}>
              {section?.title}
            </Typography>
            <Divider
              style={{ flexGrow: 1, alignSelf: "center", marginLeft: 12 }}
            />
          </Box>

          {section?.type === "images" &&
            Array.isArray(section?.data) &&
            section.data.length > 0 && (
              <Box className={styles.containerImageCards}>
                {section.data.map((item, idx) => (
                  <PropertyImageCard
                    key={idx}
                    data={item}
                    setRefetchDataPropertyImage={setRefetchDataPropertyImage}
                  />
                ))}
              </Box>
            )}

          {section?.type === "videos" &&
            Array.isArray(section?.data) &&
            section.data.length > 0 && (
              <Box className={styles.containerImageCards}>
                {section.data.map((item, idx) => (
                  <PropertyVideoCard
                    key={idx}
                    data={item}
                    setRefetchDataPropertyVideo={setRefetchDataPropertyVideo}
                  />
                ))}
              </Box>
            )}
        </Box>
      ))}
    </>
  );
}

export default SectionPropertyGalleryList;
